import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { SignalsStoreService } from '../signals-store.service';

@Component({
  selector: 'app-blank',
  imports: [],
  template: ``,
})
export class BlankComponent implements OnInit, OnDestroy {

  signalsStoreService = inject(SignalsStoreService);

  ngOnInit(): void {
    this.signalsStoreService.setIsInBlankComponent(true);
  }

  ngOnDestroy(): void {
    this.signalsStoreService.setIsInBlankComponent(false);
  }
}
